<template>
  <div class="wrapper">
    <!-- <h1>camera扫一扫模块</h1> -->
    <van-field
      ref="inputValue"
      v-model="inputValue"
      class="scanner-field"
      type="text"
      enterkeyhint="done"
      :placeholder="placeholder || '请扫描'"
      autocomplete="off"
      validate-first
      :disabled="disabled"
      :readonly="readonly"
      @keyup.enter="onEnter"
      @input="onInput"
    >
      <template #right-icon>
        <!-- OCR识别按钮（根据enableImageUpload控制显示） -->
        <ImageUploadInput
          v-if="enableImageUpload"
          :value="inputValue"
          :field-name="'scanner'"
          :field-title="'扫码输入'"
          :action="'/relay/cosfile/index'"
          :new-choose-image="false"
          :ocr-callback="null"
          :extra-prompt="''"
          :process-definition-key="processDefinitionKey"
          @ocr-text-selected="handleOcrTextSelected"
        />
        <!-- 扫码图标 -->
        <div @click="newToScan" class="scan-icon" >
          <van-icon name="scan" size="26px" />
        </div>
      </template>
    </van-field>

    <div v-if="!isQr" class="scanner-overlay">
      <QrScanner
        ref="scanner"
        :auto-start="true"
        :show-result-modal="false"
        :enable-history="false"
        :enable-album="!isPhotoAlbumDisabled"
        :show-toolbar="false"
        torch-always
        :closable="true"
        @decode="onScanDecode"
        @close="close"
        @error="onError"
      />
    </div>
  </div>
</template>

<script>
// import wx from "weixin-js-sdk";
import axios from 'axios';
import { mapGetters } from 'vuex';
import store from '@/store';
import QrScanner from './qr-scanner/QrScanner.vue';
import ImageUploadInput from './ImageUploadInput.vue';

export default {
  components: {
    QrScanner,
    ImageUploadInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    enableImageUpload: {
      type: Boolean,
      default: false,
    },
    processDefinitionKey: {
      type: String,
      default: '',
    },
    photoAlbumDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 实时签名
      signatrue: '',
      timestamp: '',
      // 扫描数据
      inputValue: '',

      isQr: true,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (!this.multiple) {
          this.inputValue = newVal;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getSignatrue();
    // 拦截浏览器返回键：扫码层打开时不退出页面，而是关闭覆盖层
    window.addEventListener('popstate', this.onPopstate);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onPopstate);
  },
  computed: {
    ...mapGetters(['getConfigItem']),
    /** 是否禁用相册（由父组件 photoAlbumDisabled 属性 + 全局配置共同控制） */
    isPhotoAlbumDisabled() {
      return !!(this.photoAlbumDisabled && this.getConfigItem('photoAlbumDisabled') === '1');
    },
  },
  methods: {
    // 处理OCR识别的文字
    handleOcrTextSelected(text) {
      // OCR识别的文字追加到输入框内容中
      const currentValue = this.inputValue || '';
      this.inputValue = currentValue ? `${currentValue} ${text}` : text;
      this.$emit('input', this.inputValue);
    },
    
    close() {
      console.log("触发了scanner的关闭");
      this.isQr = true;
      // 移除之前 push 的历史状态，避免用户按"前进"时又回到扫码层
      window.history.back();
    },

    /** 拦截浏览器/手机返回键：扫码层打开时关闭覆盖层，不退出页面 */
    onPopstate() {
      if (!this.isQr) {
        // 扫码层正在显示，阻止返回上一页，改为关闭扫码层
        this.isQr = true;
        // 重新推一条占位状态，防止继续回退
        window.history.pushState({ scannerOverlay: true }, '', window.location.href);
      }
    },

    newToScan() {
      console.log(this.photoAlbumDisabled,"this.photoAlbumDisabled");
      
      if (this.photoAlbumDisabled && this.getConfigItem('photoAlbumDisabled') === '1') {
        this.isQr = false;
        // 推入一条历史记录，使用户按返回键时触发 popstate 而非直接退出页面
        window.history.pushState({ scannerOverlay: true }, '', window.location.href);
        // QrScanner 已设置 :auto-start="true"，挂载后自动开启相机，无需手动 start()
      } else {
        this.toScan();
      }
    },

    onEnter() {
      this.$emit('enter', this.inputValue);
      if (this.$refs.inputValue) {
        this.$refs.inputValue?.focus();
      } else {
        return;
      }
      if (this.multiple) {
        this.inputValue = '';
        this.$emit('input', this.inputValue);
      }
    },

    onError(error) {
      console.log('扫码失败，内容是：', error);
    },

    onScanDecode(payload) {
      console.log('扫码成功，内容是：', payload);
      // 立即停止扫描器，防止其 500ms 后自动继续扫描
      if (this.$refs.scanner) {
        this.$refs.scanner.stop();
      }
      this.inputValue = payload.text;
      console.log('扫码结果:', payload.text);
      this.onEnter();
      this.isQr = true;
      // 扫码成功关闭后，清理历史记录
      window.history.back();
    },
    
    onInput() {
      this.$emit('input', this.inputValue);
    },
    getSignatrue() {
      const data = {
        Url: window.location.href.split('#')[0],
        Noncestr: 'otob',
        Timestamp: `${Math.round(new Date() / 1000)}`,
      };
      // 获取触发接口时的时间戳
      this.timestamp = data.Timestamp * 1;
      axios
        .post(this.getConfigItem('signature'), data, {
          headers: {
            authToken: sessionStorage.getItem('AuthToken'),
                userid: sessionStorage.getItem('userid'),
          },
        })
        .then((res) => {
          this.signatrue = res.data.signature;
          // Aegis上报：获取签名结果
          this.reportAegis({
            action: 'get_signature_result',
            hasSignature: !!res.data.signature,
            signature: res.data.signature ? res.data.signature.substring(0, 8) + '...' : '',
            responseData: JSON.stringify(res.data).substring(0, 200),
          });
        })
        .catch((err) => {
          console.log(err);
          // Aegis上报：获取签名失败
          this.reportAegis({
            action: 'get_signature_error',
            error: err ? (err.message || JSON.stringify(err)) : 'unknown',
            url: this.getConfigItem('signature'),
          });
          err && alert(JSON.stringify(err));
        });
    },

    toScan() {
      try {
        window.wx.config({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 在测试没问题之后，关闭debug模式，防止弹窗
        appId: sessionStorage.getItem('appid') || this.getConfigItem('corpID'), // 必填，企业微信的corpID
          timestamp: this.timestamp, // 必填，生成签名的时间戳
          nonceStr: 'otob', // 必填，生成签名的随机串
          signature: this.signatrue, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: ['scanQRCode'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        });
        wx.error((e) => {
          // Aegis上报：wx.config 配置失败
          this.reportAegis({
            action: 'wx_config_error',
            error: e ? JSON.stringify(e) : 'unknown',
          });
          e && alert(JSON.stringify(e));
        });
        window.wx.ready((e) => {
          window.wx.scanQRCode({
            desc: 'scanQRCode desc',
            needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
            scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是条形码（一维码），默认二者都有
            success: (res) => {
              // 回调
              const result = res.resultStr; // 当needResult为1时返回处理结果
              // 扫描结果传递到父组件
              this.inputValue = result;
              this.onEnter();
            },
            error: (res) => {
              // Aegis上报：scanQRCode 扫码失败
              this.reportAegis({
                action: 'scan_qrcode_error',
                error: res ? (res.errMsg || JSON.stringify(res)) : 'unknown',
              });
              res && alert(JSON.stringify(res));
              if (res.errMsg.indexOf('function_not_exist') > 0) {
                alert('版本过低请升级');
              }
            },
          });
        });
      } catch (e) {
        // Aegis上报：toScan 整体异常
        this.reportAegis({
          action: 'to_scan_exception',
          error: e ? (e.message || JSON.stringify(e)) : 'unknown',
        });
        e && alert(JSON.stringify(e));
      }
    },

    // Aegis打点上报封装方法
    reportAegis(data) {
      try {
        const aegis = store.state.user?.aegis;
        if (!aegis) {
          console.warn('[Scanner] Aegis 未初始化');
          return;
        }
        const reportData = {
          ...data,
          component: 'Scanner',
          timestamp: new Date().toISOString(),
        };
        aegis.infoAll({
          msg: JSON.stringify(reportData),
          ext1: 'scanner',
          trace: `scanner-${data.action}`,
        });
        console.log('[Scanner] Aegis 上报:', reportData);
      } catch (reportError) {
        console.error('[Scanner] Aegis上报失败:', reportError);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  .van-cell {
    padding: 0;
    &::after {
      display: none !important;
    }
  }
}
.scanner-field.van-cell.van-field {
  /deep/ .van-cell__value.van-cell__value--alone.van-field__value {
    overflow: visible;
  }
  
  /deep/ .van-field__right-icon {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.scan-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.scan-icon-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* 扫码器全屏覆盖层 */
.scanner-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #0f172a;
}
</style>
